import { render } from "./receiptZendesk.vue?vue&type=template&id=69186ed6&scoped=true"
import script from "./receiptZendesk.vue?vue&type=script&lang=js"
export * from "./receiptZendesk.vue?vue&type=script&lang=js"

import "./receiptZendesk.vue?vue&type=style&index=0&id=69186ed6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69186ed6"]])

export default __exports__